import PropTypes from "prop-types"
import React from "react"

const WorkOrderHeader = ({ workOrder, utilityActions }) => {
  return (
    <div className="mb-4 flex items-center justify-between">
      <h1 className="text-xl font-semibold">{workOrder.displaySequentialId}</h1>
      {utilityActions && (
        <div className="flex items-center gap-2">{utilityActions}</div>
      )}
    </div>
  )
}

WorkOrderHeader.propTypes = {
  workOrder: PropTypes.shape({
    displaySequentialId: PropTypes.string.isRequired,
  }).isRequired,
  utilityActions: PropTypes.node,
}

export default WorkOrderHeader
